import { useSelector } from "react-redux";
import { Fragment } from "react";
import { useIsBroker } from "@/auth/roles";
import { useUserAccount } from "@/hooks/useUserAccount";
import { ProfileSection } from "./ProfileSection";
import { DotSeparator } from "./DotSeparator";

export const ProfileAccountSection = () => {
    const user = useSelector((state) => state.user);
    const isBroker = useIsBroker();
    const { data: account } = useUserAccount();

    const email = account?.email || user?.data?.email;
    const details = [isBroker ? "Broker" : "Dispatcher", email, account?.phoneNumber].filter(Boolean);

    return (
        <ProfileSection title="Account">
            <div className="flex flex-col">
                {account?.displayName && <div className="text-lg font-medium text-cm-p-text-primary">{account.displayName}</div>}
                <div className="flex flex-wrap items-center gap-4 text-sm text-cm-p-text-secondary">
                    {details.map((detail, index) => (
                        <Fragment key={detail}>
                            {index > 0 && <DotSeparator />}
                            <span>{detail}</span>
                        </Fragment>
                    ))}
                </div>
            </div>
        </ProfileSection>
    );
};
